module.exports = __webpack_public_path__ + "static/media/black-arrow.fee53987.svg";